import React from "react";
import { motion } from "framer-motion";

interface SectionCardProps {
  id?: string;
  title: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ id, title, children }) => (
  <motion.section
    id={id}
    className="rounded-3xl border border-white/5 bg-slate-900/80 p-6 shadow-lg shadow-slate-950/50 backdrop-blur dark:bg-white/80 dark:border-slate-200/80 dark:shadow-slate-200/40"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.25 }}
    transition={{ duration: 0.4, ease: "easeOut" }}
  >
    <div className="mb-4 flex items-center justify-between gap-3">
      <h2 className="text-sm font-semibold tracking-wide text-slate-100 dark:text-slate-900">
        {title}
      </h2>
      <span className="inline-flex items-center rounded-full border border-slate-700/60 bg-slate-900/80 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-400 dark:bg-slate-100/80 dark:border-slate-300 dark:text-slate-500">
        section
      </span>
    </div>
    <div className="space-y-3 text-sm">{children}</div>
  </motion.section>
);

export default SectionCard;
